/**
 * Unsaved work on the mounted mobile screen, for the App-level layout decision.
 *
 * useMobileHandoffView (App.jsx) chooses between the phone and desktop apps but
 * sits outside the lazily loaded MobileApp tree, where every mobile write
 * screen registers its unsaved-work check with the navigation controller
 * (components-mobile/mobileNavigation.js). MobileApp publishes the
 * controller's check here. This module stays in the main bundle so the desktop
 * app never loads mobile code.
 */
let probe = null;

/** Publish the check. Returns a function that withdraws it. */
export function publishMobilePendingWork(nextProbe) {
  probe = typeof nextProbe === 'function' ? nextProbe : null;
  return () => {
    if (probe === nextProbe) probe = null;
  };
}

/**
 * true: the mobile screen holds unsaved work. false: nothing to lose.
 * null: no mobile screen has registered a check.
 */
export function mobilePendingWork() {
  if (!probe) return null;
  try {
    const pending = probe();
    return pending === null || pending === undefined ? null : Boolean(pending);
  } catch (error) {
    return true;
  }
}
